import { IonToggleCustomEvent } from '@ionic/core';
import { IonText, IonToggle, ToggleChangeEventDetail } from '@ionic/react';
import styles from './ToggleInput.module.css';

type Props = {
  checked?: boolean;
  labelIcon?: React.ReactNode;
  labelPlacement?: 'start' | 'end' | 'fixed';
  labelText?: React.ReactNode | string;
  labelSize?: 'base' | 'large';
  name: string;
  toggleHandler: (event: IonToggleCustomEvent<ToggleChangeEventDetail<any>>, name: string) => void;
};

const ToggleInput: React.FC<Props> = ({
  checked,
  labelIcon,
  labelPlacement = 'end',
  labelText,
  name,
  toggleHandler,
  labelSize = 'base'
}) => {
  return (
    <div className={styles.toggleContainer}>
      <IonToggle
        aria-label={name}
        data-testid={name}
        labelPlacement={labelPlacement}
        mode={'ios'}
        onIonChange={(event) => toggleHandler(event, name)}
        {...(checked !== undefined && { checked })}
      >
        {labelText && <IonText className={styles[`${labelSize}`]}>{labelText}</IonText>}
        {labelIcon && labelIcon}
      </IonToggle>
    </div>
  );
};
export default ToggleInput;
